<script>
import AccuracyPrecisionCompletion from '../AccuracyPrecisionCompletion'

export default {
  name: 'PrecisionCompletion',
  extends: AccuracyPrecisionCompletion,
  getSelected: opt => `实测值:${opt.value}`,
  computed: {
    label: () => '精密度'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Completion/Formula/PrecisionCompletion.vue